export enum ContractTaxiDriverAddRequestModel {
  ABA = "ABA",
  SABS = "SABS",
  AB = "AB",
  OTHER = "OTHER",
}

export type ContractTaxiDriverAddRequestBody = {
  validSince: string;
  validTo: string;
  model: ContractTaxiDriverAddRequestModel;
  distanceRate: number;
  haltingTimeRate: number;
  haltingTimeAfterMinutes: number;
  taxiDriverAssociationId: string;
  disabled: boolean;
  description: string;
};

type ContractTaxiDriverAddRequest = {
  validSince: string;
  validTo: string;
  model: ContractTaxiDriverAddRequestModel;
  distanceRate: number;
  haltingTimeRate: number;
  haltingTimeAfterMinutes: number;
  taxiDriverAssociationId: string;
  disabled: boolean;
  description: string;
};

export default ContractTaxiDriverAddRequest;
